import { gql } from "@apollo/client";

export const GET_CATEGORIES = gql`
  {
    listCategoriesByPriority {
      id
      name
    }
  }
`;

export const GET_ASSETS = gql`
  query getAssetListByCategoryId($categoryId: String!) {
    getAssetListByCategoryId(categoryId: $categoryId) {
      id
      name
      type
    }
  }
`;
